import { Component, OnInit, OnDestroy } from '@angular/core';
import { WeissmanModalService } from '../../WeissmanModalService';
import { FormService } from '../form.service';
import { FormAppealsListComponent } from '../Form-Appeals-List/formAppealsList.component';


@Component({
    selector: 'form-appeals',
    templateUrl: './formAppeals.component.html',
    standalone: false
})

export class FormAppealsComponent implements OnInit, OnDestroy  {
    constructor(
        private readonly _modalService: WeissmanModalService,
        private readonly _formService: FormService) {
    }

    formRevisionId: number;
    formRevisionName: string;
    annualYear: number;

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }

    get helpContent(): string {
        return `In-Use Appeals for ${this._formService.formRevision.name} in Tax Year ${this._formService.formRevisionYear.taxYear}`;
    }

    async show(): Promise<void> {
        await this._modalService.showAsync(FormAppealsListComponent, null, 'modal-xl');
    }
}
